import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaXTwitter } from "react-icons/fa6";
import { SiPatreon } from "react-icons/si";
import { FaBluesky } from "react-icons/fa6";
import { Link } from "react-router-dom";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3></h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} iplaywithdolls</h3>
          <Link style={{fontSize: "small"}} to="/terms-of-service">Policies</Link>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a href="https://patreon.com/iplaywithdolls" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <SiPatreon />
              </a>
            </li>
            <li className="social-icons">
              <a href="https://twitter.com/dollspirals" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <FaXTwitter />
              </a>
            </li>
            {/* <li className="social-icons">
              <a href="https://iplaywithdolls.bsky.social" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                <FaBluesky />
              </a>
            </li> */}
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
